import { useEffect } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

// CSS
import styles from "./loading-page.module.scss";

// Const
const loadingSpinnerSrc =
    require("../../assets/images/loading-spinner.gif").default;

export const LoadingPage = (props) => {
    /**
     * useEffect
     */

    useEffect(() => {
        const target = document.querySelector("body");
        disableBodyScroll(target);

        return () => {
            enableBodyScroll(target);
        };
    }, []);

    /**
     * End Hooks
     */

    return (
        <div className={styles["loading-page"]}>
            <img
                alt="Loading spinner"
                className={styles.spinner}
                src={loadingSpinnerSrc}
            />
        </div>
    );
};
